import { BaseHomeSchema } from '@space-lib/datahub/hotmartClub'
import { UserInfoRole } from '@space-shell/common/services/user'

type ViewPwaBannerSchemaConstructor = {
  userRole?: string
  arrivedFrom: string | 'CLUB_HOME' | 'PRODUCT_HOME'
}

export default class ViewPwaBannerSchema extends BaseHomeSchema {
  action: string
  role: string
  private arrivedFrom: string

  constructor({ userRole = UserInfoRole.VIEWER, arrivedFrom }: ViewPwaBannerSchemaConstructor) {
    super()
    this.action = 'view_pwa_banner'
    this.role = userRole
    this.arrivedFrom = arrivedFrom ?? ''
  }

  getDataHubEventData() {
    return {
      ...super.prepare(),
      pushKind: 'NOT_PUSH_EVENT',
      arrivedFrom: this.arrivedFrom,
      userRole: this.role
    }
  }
}
